import { useEffect, useState } from 'react'
import { Bell, SlidersHorizontal } from 'lucide-react'
import { useTaskStore } from '../../store/taskStore'
import Modal from '../Common/Modal'

export default function AccessibilitySettings({ iconOnly = false }: { iconOnly?: boolean }) {
  const [open, setOpen] = useState(false)
  const preferences = useTaskStore((s) => s.accessibility)
  const update = useTaskStore((s) => s.updateAccessibility)
  useEffect(() => {
    document.documentElement.dataset.largeText = String(preferences.largeText)
    document.documentElement.dataset.reducedMotion = String(preferences.reducedMotion)
    document.documentElement.dataset.compact = String(preferences.compactMode)
    document.documentElement.dataset.calm = String(preferences.calmVisuals)
    document.documentElement.classList.toggle('dark', Boolean(preferences.darkMode))
  }, [preferences])
  const toggle = (key: keyof typeof preferences) => update({ [key]: !preferences[key] })

  const triggerButton = iconOnly ? (
    <button
      type="button"
      className="flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800/60 dark:hover:text-slate-200 transition-all duration-200 hover:scale-110 active:scale-95 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none"
      onClick={() => setOpen(true)}
      title="Preferências de acessibilidade"
      aria-label="Preferências de acessibilidade"
    >
      <SlidersHorizontal size={17} />
    </button>
  ) : (
    <button className="topbar-button" onClick={() => setOpen(true)} aria-label="Preferências de acessibilidade">
      <SlidersHorizontal size={15} />
      <span className="hidden md:inline">Preferências</span>
    </button>
  )

  return <>{triggerButton}{open && <Modal title="Preferências de conforto" onClose={() => setOpen(false)}><div className="space-y-2 p-5"><p className="mb-4 text-sm text-slate-600 dark:text-slate-400">Ajuste a interface ao que ajuda você. Não há configuração certa ou errada.</p>{([
    ['darkMode', 'Modo escuro', 'Alterna a interface para tons escuros.'],
    ['reducedMotion', 'Reduzir movimentos', 'Remove rotações e animações decorativas.'],
    ['calmVisuals', 'Visual mais calmo', 'Oculta grade, gradientes e reduz sombras.'],
    ['largeText', 'Texto maior', 'Aumenta o tamanho base dos textos.'],
    ['compactMode', 'Modo compacto', 'Reduz espaços sem esconder informações.'],
    ['simpleNavigation', 'Navegação simples', 'Mostra uma lista previsível além do canvas.'],
  ] as const).map(([key, label, help]) => <label key={key} className="flex cursor-pointer items-start gap-3 rounded-xl border border-slate-200 dark:border-slate-700 p-3 hover:bg-slate-50 dark:hover:bg-slate-800/60"><input className="mt-1 h-4 w-4 accent-blue-600" type="checkbox" checked={Boolean(preferences[key])} onChange={() => toggle(key)} /><span><span className="block text-sm font-medium text-slate-800 dark:text-slate-200">{label}</span><span className="block text-xs text-slate-500 dark:text-slate-400">{help}</span></span></label>)}<button className="btn-secondary mt-3 flex w-full items-center justify-center gap-2" onClick={() => 'Notification' in window && Notification.requestPermission()}><Bell size={15} /> Ativar notificações</button></div></Modal>}</>
}
